import React from "react";
import { Switch, Route } from "react-router-dom";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fab } from "@fortawesome/free-brands-svg-icons";

import { firebaseConfig, firebaseConfigTest } from "./backend/firebaseConfig";
import firebase from "firebase/app";
import User from "./components/user";
import Auth from "./components/auth";
import Maintenance from "./components/maintenance";
import Leaderboard from "./components/leaderBoard";

import { Context } from "./backend/context";

library.add(fab);

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

function App() {
  const { uid } = React.useContext(Context);
  return (
    <div
      className="badge-dark"
      style={{
        height: "100%",
        position: "absolute",
        left: "0px",
        width: "100%",
        overflowY: "scroll",
      }}
    >
      <Switch>
        {!uid && (
          <Route exact path="/account/leaderboard" component={Leaderboard} />
        )}

        <Route path="/account" component={User} />
        <Route path="/maintenance" component={Maintenance} />

        <Route path="/" component={Auth} />
      </Switch>
    </div>
  );
}

export default App;
